import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionReportStateForm_UpdateReportInfoState_Mutation = graphql(`
  mutation MissionReportStateForm_UpdateReportInfoState(
    $actionId: Id!
    $missionId: Id!
    $reportInfoId: Id!
    $code: NonEmptyString
    $templateId: Id
    $title: NonEmptyString
    $versionData: VersionDataInput
  ) {
    updateReportInfoState(
      actionId: $actionId
      missionId: $missionId
      reportInfoId: $reportInfoId
      code: $code
      templateId: $templateId
      title: $title
      versionData: $versionData
    ) {
      _id
      reportInfos {
        _id
        stateId
      }
    }
  }
`);

export type MissionReportStateForm_UpdateReportInfoState_Result = ResultOf<
  typeof MissionReportStateForm_UpdateReportInfoState_Mutation
>;

export const useUpdateMissionReportInfoStateMutation = () =>
  useGraphQLMutation(MissionReportStateForm_UpdateReportInfoState_Mutation);
